import { render, staticRenderFns } from "./shiftApproved.vue?vue&type=template&id=14132ada&"
import script from "./shiftApproved.vue?vue&type=script&lang=js&"
export * from "./shiftApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports